import { IUnitFilter } from 'Modules/HousingAssociation/OurCompany/shared/models/Unit'
import { IContactFilters } from 'Modules/Communication/Contacts/shared/models/Contacts'
import messagesFiltersService from './messages-filters.service'
import { RootState } from 'shared/store/store'
import { MesssageFilters } from '../../../models/Message'

export interface MessagesFilterState {
  messaging: {
    messagesFilters: {
      filters: MesssageFilters
      units: {
        filters: IUnitFilter
      }
      residents: {
        filters: IContactFilters
      }
      // Responsible filter lives in shared/store/baord
    }
  }
}

const messagesFiltersSelector = (state: MessagesFilterState) => {
  return state.messaging.messagesFilters
}

export const getMessagesContactsFilters = (state: MessagesFilterState) => {
  return state.messaging.messagesFilters.residents.filters
}

export const getMessagesUnitsFilters = (state: MessagesFilterState) => {
  return state.messaging.messagesFilters.units.filters
}

export const getMessagesFilters = (state: MessagesFilterState) =>
  state.messaging.messagesFilters.filters

export const getResidentContacts = (state: RootState) => ({
  // @ts-expect-error todo
  filters: messagesFiltersSelector(state).residents.filters,
  ...messagesFiltersService.endpoints.getMessagingResidentContacts.select()(
    state
  ),
})

export const getUnits = (state: RootState) => ({
  // @ts-expect-error todo
  filters: messagesFiltersSelector(state).units.filters,
  ...messagesFiltersService.endpoints.getMessagingUnits.select()(state),
})
